import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as SiteFileQL from "queries/site-file";
import { PRIVATE } from "@common/schema/site-file/visibility";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Edit</BreadcrumbItem>
  </>
);

// Description, tags and visibility — the two fields bucketws' own file edit
// offers, plus the one that has no bucketws equivalent because it is about this
// site rather than about the object. Everything else on the row is either a
// property of the bytes (`ext`, `hash`, `size`) or bucketws' to write
// (`status`, `metadata`).
//
// `name` is NOT here even though this service owns it. It is the filename the
// person chose, and renaming it here would make the listing disagree with what
// they would get back if they downloaded the file. If that turns out to be
// wanted it is a one-line addition to this config and to SiteFileInputUpdate.
//
// Module scope, not a literal in JSX: a new `config` identity rebuilds the
// widget tree beneath the form's SchemaProvider and detaches the control being
// typed into (P139).
const EDIT_FIELDS = {
  "/Public/SiteFile/Update": {
    fields: ["description", "tags", "visibility"],
  },
};

export const Content = ({
  history,
  match: {
    params: { siteId, kind, fileId },
  },
}) => {
  const { base } = useSectionContext();

  return (
    <Mutation
      target={{ $ref: "/Public/SiteFile/Update" }}
      mutation={SiteFileQL.edit}
      update={SiteFileQL.update()}
      onMutate={({ handler, state: { values } }) => {
        handler({
          variables: {
            siteId,
            kind,
            fileId,
            // Both fields, always. SiteFileInputUpdate declares them non-null,
            // so sending only the one that changed is a GraphQL validation
            // error rather than a partial write — and the API mirrors this pair
            // on to bucketws, where the same is true.
            input: {
              description: values.description || "",
              tags: values.tags || [],
              // Sent explicitly even when nothing touched the control, and the
              // fallback is PRIVATE rather than whatever the row holds. A
              // select renders its first option whatever the form is actually
              // carrying, so a row written before this field existed shows
              // "private" while holding nothing — and the only honest way to
              // read that screen is that submitting it means private. The enum
              // is ordered so the option shown in that state is the closed one.
              visibility: values.visibility || PRIVATE,
            },
          },
        });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ state, schema, mutate, target }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: EDIT_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Save</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
